
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 448 448"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"32","y":"32","width":"384","height":"384","rx":"64","ry":"64","fill":"none","stroke":"currentColor","stroke-width":"32"}}),_c('path',{attrs:{"d":"M342.5 178.28c0 1.38-1.11 2.5-2.5 2.5h-13.5l-61.22 130.3c-.4.86-1.27 1.43-2.23 1.44h-.03c-.95 0-1.82-.53-2.24-1.38l-29.05-57.62-31.35 57.69c-.45.83-1.25 1.29-2.27 1.31-.94-.03-1.79-.58-2.19-1.43l-61.9-130.31H120a2.5 2.5 0 01-2.5-2.5v-6.6a2.5 2.5 0 012.5-2.5h49.93a2.5 2.5 0 012.5 2.5v6.6a2.5 2.5 0 01-2.5 2.5h-10.75l42.72 98.54 22.23-41.53-28.18-57h-6.78a2.5 2.5 0 01-2.5-2.5v-6.6a2.5 2.5 0 012.5-2.5h36.93a2.5 2.5 0 012.5 2.5v6.6a2.5 2.5 0 01-2.5 2.5h-6.5l16.21 35.47 19.3-35.47h-11.84c-1.39 0-2.5-1.12-2.5-2.5v-6.6c0-1.38 1.11-2.5 2.5-2.5h35.88c1.39 0 2.5 1.12 2.5 2.5v6.6c0 1.38-1.11 2.5-2.5 2.5h-7.87l-28.17 51.18 22.96 47.2 44.3-98.38h-14.04a2.5 2.5 0 01-2.5-2.5v-6.6a2.5 2.5 0 012.5-2.5H340c1.39 0 2.5 1.12 2.5 2.5v6.59z","fill":"#f60","stroke":"#f60","stroke-width":"5"}})])
          )
        }
      }
    